import React from 'react';
import { Router } from '@reach/router';
import propTypes from 'prop-types';

import { LocaleProvider } from '../../../modules/Internationalization';
import { getLocalizedPageUrl } from '../../../modules/Navigation';

import { renderComponent } from './utils';
import Categories from './Categories';
import Posts from './Posts';
import SinglePost from './SinglePost';

const Insights = ({ locale }) => {
  const basePath = getLocalizedPageUrl('insights', locale);

  // https://github.com/reach/router/issues/242

  return (
    <LocaleProvider locale={locale}>
      <Router basepath={basePath}>
        <Categories path="/" default>
          <Posts path="/_/:categoryId" />
          <Posts path="/" />
        </Categories>
        <SinglePost path="/:postId" />
        <SinglePost path="/sk/:postId" />
      </Router>
    </LocaleProvider>
  );
};

Insights.propTypes = {
  locale: propTypes.string,
};

export default renderComponent(Insights, '#insights');



// WEBPACK FOOTER //
// ./src/scripts/modules/Insights/index.js